var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadApplication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 238308"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40497",
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_6875_9358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 20.857H28.8C27.5199 20.857 26.8794 20.857 26.3905 20.6079C25.9604 20.3888 25.611 20.0391 25.3919 19.609C25.1427 19.1201 25.1427 18.4801 25.1427 17.2V14M31.9998 30.9141V21.229C31.9998 20.67 31.9993 20.3904 31.9362 20.1274C31.8802 19.8941 31.788 19.6712 31.6627 19.4667C31.5213 19.236 31.3242 19.0384 30.9289 18.6431L27.357 15.0711C26.9617 14.6758 26.764 14.4782 26.5333 14.3368C26.3288 14.2115 26.1059 14.1191 25.8727 14.0632C25.6097 14 25.33 14 24.771 14H19.6573C18.3772 14 17.7367 14 17.2478 14.2491C16.8177 14.4683 16.4683 14.818 16.2491 15.248C16 15.737 16 16.377 16 17.6571V30.9141C16 32.1942 16 32.8342 16.2491 33.3231C16.4683 33.7532 16.8177 34.1028 17.2478 34.322C17.7367 34.5711 18.3772 34.5711 19.6573 34.5711H28.3429C29.623 34.5711 30.2626 34.5711 30.7516 34.322C31.1816 34.1028 31.5318 33.7532 31.7509 33.3231C32 32.8342 31.9998 32.1942 31.9998 30.9141Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.0008 24.2852L24.0008 31.1422M24.0008 31.1422L26.4293 28.8565M24.0008 31.1422L21.5723 28.8565",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6875_9358",
    x1: -13.5105,
    y1: 0.00000269178,
    x2: 58.2718,
    y2: 6.82133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678AF5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadApplication);
export default __webpack_public_path__ + "static/media/DownloadApplication.95fc1652c8ee0d3314f48ef31541a12a.svg";
export { ForwardRef as ReactComponent };